<div class="container p-3">
    <div class="row">
        <div class="col">
            <h3>Search devices</h3>
            <div class="mb-3">
                <div class="input-group">
                    <input #serialNumberInput type="text" placeholder="Search devices..." class="form-control" value="{{ serialNumber }}" maxlength="64" (keyup.enter)="searchDevices(serialNumberInput.value)">
                    <button class="btn btn-primary" (click)="searchDevices(serialNumberInput.value)">
                        <i class="fas fa-search"></i> Search
                    </button>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="row" *ngIf="devices && devices.length == 0">
        <div class="col" *ngIf="serialNumber">
            <i class="fas fa-exclamation-triangle"></i> No device found for <kbd class="align-bottom bg-light text-dark">{{ serialNumber }}</kbd>
        </div>
    </div>
    <div *ngIf="devices && devices.length > 0">
        <div class="row">
            <div class="col-auto">
                <select #productSelectControl class="form-select" (change)="updateDevicesByProduct(productSelectControl.value)">
                    <option *ngFor="let product of products" value="{{ product.product }}">{{ product.product }} ({{ product.count }})</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-4" style="padding-top: 15px; padding-bottom: 15px;" *ngFor="let device of devicesByProduct">
                <div class="px-3 py-2 border bg-light">
                    <div>serial number: {{ device.serialNumber }}</div>
                    <div>mac address: {{ device.macAddress }}</div>
                    <div>first pairing: {{ device.insertDatetime | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}</div>
                    <div>last pairing: {{ device.updateDatetime | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}</div>
                    <div>last deleted: {{ device.deleteDatetime | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}</div>
                    <div>deleted: {{ device.deleted }}</div>
                    <hr>
                    <div class="float-end" *ngIf="!device.account || !device.profile">
                        <div class="spinner-border spinner-border-sm text-secondary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div>
                        user: <a [routerLink]="['/users', device.accountId]"><code>#{{ device.accountId }}</code></a>
                    </div>
                    <div *ngIf="device.account?.email || (!device.account?.facebook && !device.account?.google && !device.account?.twitter)">
                        email: <a href="mailto:{{ device.account?.email}}">{{ device.account?.email }}</a>
                    </div>
                    <div *ngIf="device.account?.facebook">
                        facebook: {{ device.account?.facebook }}
                    </div>
                    <div *ngIf="device.account?.google">
                        google: {{ device.account?.google }}
                    </div>
                    <div *ngIf="device.account?.twitter">
                        twitter: {{ device.account?.twitter }}
                    </div>
                    <div>firstname: {{ device.profile?.firstname }}</div>
                    <div>lastname: {{ device.profile?.lastname }}</div>
                    <div>nickname: {{ device.profile?.nickname }}</div>
                    <div>country: {{ device.profile?.country }}</div>
                    <div>
                        avatar: <img src="{{ device.profile?.avatar }}" width="64px" height="64px" class="rounded-circle">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>